import { useState } from 'react';
import api from '../../lib/api.js';

const blank = { client_type:'individual', legal_name:'', first_name:'', last_name:'', vat_number:'', tax_code:'', email:'', phone:'', street:'', city:'', province:'', zip:'' };

export default function ClientSelector({ value, clients, onChange, onClientsUpdate }) {
  const [search, setSearch] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [nc, setNc] = useState(blank);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const filtered = search
    ? clients.filter(c => {
        const q = search.toLowerCase();
        return (c.display_name || c.legal_name || '').toLowerCase().includes(q)
          || (c.email || '').toLowerCase().includes(q)
          || (c.vat_number || '').toLowerCase().includes(q)
          || (c.tax_code || '').toLowerCase().includes(q);
      })
    : clients;
  function reset() { setNc(blank); setErr(''); }
  async function handleCreate(e) {
    e.preventDefault(); setErr(''); setSaving(true);
    try {
      const res = await api.post('/clients', {
        client_type: nc.client_type,
        legal_name: nc.legal_name?.trim() || 'Cliente generico',
        first_name: nc.first_name, last_name: nc.last_name,
        vat_number: nc.vat_number, tax_code: nc.tax_code,
        email: nc.email, phone: nc.phone,
        street: nc.street, city: nc.city,
        province: nc.province, zip: nc.zip,
        country: 'Italia', status: 'active',
      });
      if (!res.ok) throw new Error(res.error || 'Creazione fallita');
      onClientsUpdate(prev => [...prev, res.data]);
      onChange(String(res.data.id), res.data.display_name || res.data.legal_name);
      setShowNew(false); reset();
    } catch (ex) { setErr(ex?.message || 'Errore di rete'); }
    finally { setSaving(false); }
  }
  return (
    <div className="relative">
      <div className="flex gap-2">
        <input className="input flex-1" placeholder="Cerca per nome, email, P.IVA..."
          value={search} onChange={e => setSearch(e.target.value)} onFocus={() => setShowNew(false)} />
        <button type="button" className="btn btn-primary text-xs whitespace-nowrap"
          onClick={() => { setShowNew(v => !v); setSearch(''); }}>Nuovo cliente</button>
      </div>
      {!showNew && search && (
        <ul className="absolute z-50 mt-1 w-full max-h-48 overflow-auto rounded-md border border-line bg-panel p-1 shadow-lg">
          {filtered.length === 0 && <li className="px-3 py-2 text-xs text-surface-4">Nessun risultato</li>}
          {filtered.map(c => (
            <li key={c.id} className={`px-3 py-2 rounded cursor-pointer text-sm hover:bg-line ${String(c.id) === String(value) ? 'bg-brand-600/20 text-brand-300' : 'text-surface-2'}`}
              onClick={() => { onChange(String(c.id), c.display_name || c.legal_name); setSearch(''); }}>
              <div className="font-medium">{c.display_name || c.legal_name}</div>
              <div className="text-xs text-surface-4">{c.email || c.vat_number || c.tax_code || ''}</div>
            </li>
          ))}
        </ul>
      )}
      {showNew && (
        <div className="mt-2 card-elevated p-4 space-y-3">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-semibold text-surface">Nuovo cliente</h4>
            <button type="button" className="btn btn-ghost text-xs" onClick={() => { setShowNew(false); reset(); }}>X</button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Ragione sociale / Nome *</span><input className="input" value={nc.legal_name} onChange={e => setNc({ ...nc, legal_name: e.target.value })} required autoFocus /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Tipo</span><select className="input" value={nc.client_type} onChange={e => setNc({ ...nc, client_type: e.target.value })}><option value="individual">Persona fisica</option><option value="company">Azienda</option></select></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Nome</span><input className="input" value={nc.first_name} onChange={e => setNc({ ...nc, first_name: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Cognome</span><input className="input" value={nc.last_name} onChange={e => setNc({ ...nc, last_name: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">P.IVA</span><input className="input" value={nc.vat_number} onChange={e => setNc({ ...nc, vat_number: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Codice fiscale</span><input className="input" value={nc.tax_code} onChange={e => setNc({ ...nc, tax_code: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Email</span><input className="input" type="email" value={nc.email} onChange={e => setNc({ ...nc, email: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Telefono</span><input className="input" value={nc.phone} onChange={e => setNc({ ...nc, phone: e.target.value })} /></label>
            <label className="flex flex-col gap-1 sm:col-span-2"><span className="text-surface-4 text-xs">Indirizzo</span><input className="input" value={nc.street} onChange={e => setNc({ ...nc, street: e.target.value })} placeholder="Via / Piazza" /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Città</span><input className="input" value={nc.city} onChange={e => setNc({ ...nc, city: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">CAP</span><input className="input" value={nc.zip} onChange={e => setNc({ ...nc, zip: e.target.value })} /></label>
            <label className="flex flex-col gap-1"><span className="text-surface-4 text-xs">Prov.</span><input className="input" value={nc.province} onChange={e => setNc({ ...nc, province: e.target.value })} placeholder="MI" /></label>
          </div>
          {err && <div className="text-xs text-danger">{err}</div>}
          <div className="flex justify-end gap-2">
            <button type="button" className="btn btn-ghost text-xs" onClick={() => { setShowNew(false); reset(); }}>Annulla</button>
            <button type="button" className="btn btn-primary text-xs" disabled={saving} onClick={handleCreate}>{saving ? 'Salvataggio...' : 'Crea e seleziona'}</button>
          </div>
        </div>
      )}
    </div>
  );
}
